import Video from "../assets/video.svg";

const FeaturedAboutus = () => {
  return (
    <div className="grid bg-primary-light px-6 mt-4">
      <div className="h-full w-full rounded-lg flex justify-center">
        <img src={Video} alt="logo2" width={1830} height={889} />
      </div>
    </div>
  );
};

export default FeaturedAboutus;
